module.exports = __webpack_public_path__ + "static/media/surat-jalan.015fc8e8.png";